import { render, staticRenderFns } from "./product_restaurants.vue?vue&type=template&id=0e396a46&scoped=true&"
import script from "./product_restaurants.vue?vue&type=script&lang=js&"
export * from "./product_restaurants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e396a46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e396a46')) {
      api.createRecord('0e396a46', component.options)
    } else {
      api.reload('0e396a46', component.options)
    }
    module.hot.accept("./product_restaurants.vue?vue&type=template&id=0e396a46&scoped=true&", function () {
      api.rerender('0e396a46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/tabs/product_restaurants.vue"
export default component.exports